import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TravelService } from 'src/app/services/travel.service';
import { environment } from 'src/environments/environment';
import { ContractedInvoice } from 'src/app/models/contracted-invoice';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ToastrManager } from 'ng6-toastr-notifications';

import * as _ from 'lodash';
import { uniqBy } from 'lodash';
import { Travel } from '../../../../models/travel';

@Component({
  selector: 'app-travel-contracted',
  templateUrl: './travel-contracted.component.html',
  styleUrls: ['./travel-contracted.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class TravelContractedComponent implements OnInit {

  date1:Date = new Date();
  date2:Date = new Date();
  data = [];
  dataAll = [];
  totales = [];
  actualSelected;
  selectedModal;
  loading:boolean = false;
  contracted:ContractedInvoice = new ContractedInvoice();
  total:number = 0;
  subtotal:number = 0;
  expand:boolean = false;
  //Nuevo Filtro, 1 - Internos, 2 - Contratados, 3 - Todos
  travelTypes = [ {id: 1, name: 'Internos'}, {id: 2, name: 'Contratados'}, {id: 3, name: 'Todos'} ];
  travelType: number = 2;
  travelTypeName: string = null;
  //Filtros Extra
  brand:any[] = [];
  customer:any[] = [];
  product:any[] = [];
  destination:any = null;
  //Catalogos
  brandList:any[] = [];
  customersList: string[] = [];
  productsList: string[] = [];
  travelID: string = null;
  //Settings
  brandSettings = {};
  customerSettings = {};
  productSettings = {};
  //Viajes Seleccionados por ID (Reporte Excel -> Ajuste Amalia)
  travelByID: number = null; //Para buscar el viaje
  travelSelectedById: Travel = null; //Para guardar el viaje encontrado
  travelsSelectedById: Travel[] = []; //Para guardar y mostrar los viajes obtenidos de la busqueda
  travelFilterByID: boolean = false; //Cuando se muestran viajes por busqueda por ID
  travelFilterNormal: boolean = false; //Opcion de filtrado default

  constructor(private travelServ: TravelService, private modalServ: NgbModal, private utl: UtilitiesService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.brandSettings = { 
          singleSelection: false, 
          text:"Selecciona Contratista",
          selectAllText:'Marcar Todos los Contratistas',
          unSelectAllText:'Desmarcar Todos los Contratistas',
          enableSearchFilter: true,
          enableCheckAll: false,
          classes:"myclass custom-class"
    };

    this.customerSettings = {
          singleSelection: false, 
          text:"Selecciona Cliente",
          selectAllText:'Marcar Todos los Clientes',
          unSelectAllText:'Desmarcar Todos los Clientes',
          enableSearchFilter: true,
          enableCheckAll: false,
          classes:"myclass custom-class"
    };
    
    this.productSettings = {
          singleSelection: false, 
          text:"Selecciona Producto",
          selectAllText:'Marcar Todos los Productos',
          unSelectAllText:'Desmarcar Todos los Prodcutos',
          enableSearchFilter: true,
          enableCheckAll: false,
          classes:"myclass custom-class"
    };
  }

  onItemSelect(item:any, opc:number = 0){
    switch(opc)
    {
      case 1: this.updateFilter(); this.formatData(); break;
      case 2: this.updateFilter(); this.formatData(); break;
      case 3: this.updateFilter(); this.formatData(); break;
      default: this.toastr.infoToastr('Debes marcar una opción válida', '', {enableHTML:true});
    }
  }

  OnItemDeSelect(item:any, opc:number = 0){
    switch(opc)
    {
      case 1: this.updateFilter(); this.formatData(); break;
      case 2: this.updateFilter(); this.formatData(); break;
      case 3: this.updateFilter(); this.formatData(); break;
      default: this.toastr.infoToastr('Debes desmarcar una opción válida', '', {enableHTML:true});
    }
  }

  onDeSelectAll(items: any, opc:number = 0){
    switch(opc)
    {
      case 1: this.updateFilter(); this.formatData(); break;
      case 2: this.updateFilter(); this.formatData(); break;
      case 3: this.updateFilter(); this.formatData(); break;
      default: this.toastr.infoToastr('La opción no es válida o está reconocida', '', {enableHTML:true});
    }
  }

  search() {
    if(this.date1 <= this.date2){
      this.loading = true;
      this.travelServ.getContractedTravels(this.date1, this.date2, this.travelType).then(response => {
        this.dataAll = response;
        this.data = this.dataAll;
        this.getDefaultValues();
        this.setValuesBrand(); //Filtros
        this.setValuesCustomer(); //Filtros
        this.setValuesProduct(); //Filtros
        this.formatData();
        this.travelTypeName = this.travelTypes.find(e => e.id == this.travelType).name;
        this.travelFilterByID = false;
        this.travelFilterNormal = true; //Se deshabilita la opcion de filtrar por ID´s de Viajes 
        this.loading = false;
      }, error => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      });
    }else{
      this.toastr.infoToastr('Rango de fechas invalido. Por favor ingresa un rango de fechas válido', '', {enableHTML: true});
    }
  }

  updateFilter(){
    this.data = this.dataAll;
    this.utl.filterByParams(this.data, this.brand, this.customer, this.product, this.destination, dataAll => this.data = dataAll);
  }

  formatData(){
    this.data = _.chain(this.data)
                .groupBy("id")
                .map((value, key) => ({id: key, 
                                      brand: _.map(_.uniqBy(value, 'brand'),'brand'),
                                      order_id: _.map(_.uniqBy(value, 'order_id'), 'order_id'),
                                      delivery_date: _.map(_.uniqBy(value,'delivery_date'), 'delivery_date'),
                                      target_customer: _.map(_.uniqBy(value, 'target_customer'), 'target_customer'),
                                      product_name: _.map(_.uniqBy(value, 'product_name'), 'product_name'),
                                      ton: _.map(_.uniqBy(value, 'order_id'), 'ton'),
                                      total_ton: _.sumBy(_.map(_.uniqBy(value, 'order_id'), 'ton'), (t) => { return Number(t); }), //Sumatoria Toneladas por 
                                      target_customer_address: _.map(_.uniqBy(value, 'target_customer_address'), 'target_customer_address'),
                                      ticket_number: _.map(_.uniqBy(value, 'ticket_number'), 'ticket_number'),
                                      invoice: _.map(_.uniqBy(value, 'invoice'), 'invoice'),
                                      subtotal: _.map(_.uniqBy(value, 'subtotal'), 'subtotal'),
                                      iva: _.map(_.uniqBy(value, 'iva'), 'iva'),
                                      retencion: _.map(_.uniqBy(value, 'retencion'), 'retencion'),
                                      retencion_isr: _.map(_.uniqBy(value, 'retencion_isr'), 'retencion_isr'),
                                      retencion_isr_is: _.map(_.uniqBy(value, 'retencion_isr_is'), 'retencion_isr_is'),
                                      total: _.map(_.uniqBy(value, 'total'), 'total'),
                                      ncre: _.map(_.uniqBy(value, 'ncre'), 'ncre'),
                                      ncre_is: _.map(_.uniqBy(value, 'ncre_is'), 'ncre_is'),
                                      ncre_subtotal: _.map(_.uniqBy(value, 'ncre_subtotal'), 'ncre_subtotal'),
                                      ncre_iva: _.map(_.uniqBy(value, 'ncre_iva'), 'ncre_iva'),
                                      ncre_retencion: _.map(_.uniqBy(value, 'ncre_retencion'), 'ncre_retencion'),
                                      ncre_retencion_isr: _.map(_.uniqBy(value, 'ncre_retencion_isr'), 'ncre_retencion_isr'),
                                      ncre_total: _.map(_.uniqBy(value, 'ncre_total'), 'ncre_total'),
                                      ncar: _.map(_.uniqBy(value, 'ncar'), 'ncar'),
                                      ncar_is: _.map(uniqBy(value, 'ncar_is'), 'ncar_is'),
                                      ncar_subtotal: _.map(_.uniqBy(value, 'ncar_subtotal'), 'ncar_subtotal'),
                                      ncar_iva: _.map(_.uniqBy(value, 'ncar_iva'), 'ncar_iva'),
                                      ncar_retencion: _.map(_.uniqBy(value, 'ncar_retencion'), 'ncar_retencion'),
                                      ncar_retencion_isr: _.map(_.uniqBy(value, 'ncar_retencion_isr'), 'ncar_retencion_isr'),
                                      ncar_total: _.map(_.uniqBy(value, 'ncar_total'), 'ncar_total'),
                                      inplug: _.map(_.uniqBy(value, 'inplug'), 'inplug'),
                                      inplug_is: _.map(_.uniqBy(value, 'inplug_is'), 'inplug_is'),
                                      inplug_subtotal: _.map(_.uniqBy(value, 'inplug_subtotal'), 'inplug_subtotal'),
                                      inplug_iva: _.map(_.uniqBy(value, 'inplug_iva'), 'inplug_iva'),
                                      inplug_retencion: _.map(_.uniqBy(value, 'inplug_retencion'), 'inplug_retencion'),
                                      inplug_retencion_isr: _.map(_.uniqBy(value, 'inplug_retencion_isr'), 'inplug_retencion_isr'),
                                      inplug_total: _.map(_.uniqBy(value, 'inplug_total'), 'inplug_total')
                                    }))
                .value();
    //Totales Documentos Viajes
    this.totales = [];
    this.totales.push({invoice_subtotal:_.sumBy(_.uniqBy(this.data, 'id'), (i) => {return Number(i.subtotal)})});
    this.totales.push({invoice_total:_.sumBy(_.uniqBy(this.data, 'id'), (i) => {return Number(i.total)})});
    this.totales.push({ncre_subtotal: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.ncre_subtotal)})});
    this.totales.push({ncre_total: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.ncre_total)})});
    this.totales.push({ncar_subtotal: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.ncar_subtotal)})});
    this.totales.push({ncar_total: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.ncar_total)})});
    this.totales.push({inplug_subtotal: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.inplug_subtotal)})});
    this.totales.push({inplug_total: _.sumBy(_.uniqBy(this.data, 'id'), (ncre) => {return Number(ncre.inplug_total)})});
  }

  setValuesBrand(){
    let brandsTemp = []
    _.forEach(_.map(_.uniqBy(this.data, 'brand'), 'brand'), function(b){
      brandsTemp.push({id: b, itemName: b});
    });
    this.brandList = brandsTemp;
  }

  setValuesCustomer(){
    let customersTemp = [];
    _.forEach(_.map(_.uniqBy(this.data, 'target_customer'), 'target_customer'), function(c){
      customersTemp.push({id: c, itemName: c});
    });
    this.customersList = customersTemp;
  }

  setValuesProduct(){
    let productTemp = [];
    _.forEach(_.map(_.uniqBy(this.data, 'product_name'), 'product_name'), function(p){
      productTemp.push({id: p, itemName: p});
    });
    this.productsList = productTemp;
  }

  getDefaultValues(){
    this.travelID = null;
    this.brand = [];
    this.brandList = [];
    this.customer = [];
    this.customersList = [];
    this.destination = null;
    this.product = [];
    this.productsList = [];
    //Opcion de Filtrado
    this.travelFilterByID = false;
    this.travelFilterNormal = true;
  }

  select(modal, row) {
    this.contracted.travel_id = row.id;
    this.contracted.subtotal = (row.subtotal) ? this.Number(row.subtotal) : null;
    this.contracted.iva = (row.iva) ? this.Number(row.iva) : null;
    this.contracted.retencion = (row.retencion) ? this.Number(row.retencion) : null;
    this.contracted.total = (row.total) ? this.Number(row.total) : null;
    this.contracted.invoice = (row.invoice) ? row.invoice.join("") : null;
    this.contracted.description = (row.description) ? row.description.join("") : null;
    this.contracted.retencion_isr = (row.retencion_isr) ? this.Number(row.retencion_isr) : null;
    this.contracted.retencion_isr_is = (row.retencion_isr_is) ? Boolean(row.retencion_isr_is) : null;

    this.contracted.ncre = (row.ncre) ? row.ncre.join("") : null;
    this.contracted.ncre_is = (row.ncre_is) ? Boolean(row.ncre_is) : null;
    this.contracted.ncre_subtotal = (row.ncre_subtotal) ? this.Number(row.ncre_subtotal) : null;
    this.contracted.ncre_iva = (row.ncre_iva) ? this.Number(row.ncre_iva) : null;
    this.contracted.ncre_retencion = (row.ncre_retencion) ? this.Number(row.ncre_retencion) : null;
    this.contracted.ncre_retencion_isr = (row.ncre_retencion_isr) ? this.Number(row.ncre_retencion_isr) : null;
    this.contracted.ncre_retencion_isr_is = (row.ncre_retencion_isr_is) ? Boolean(row.ncre_retencion_isr_is) : null;
    this.contracted.total = (row.total) ? this.Number(row.total) : null;
    this.contracted.ncre_description = (row.ncre_description) ? row.ncre_description.join("") : null;

    this.contracted.ncar = (row.ncar) ? row.ncar.join("") : null;
    this.contracted.ncar_is = (row.ncar_is) ? Boolean(row.ncar_is) : null;
    this.contracted.ncar_subtotal = (row.ncar_subtotal) ? this.Number(row.ncar_subtotal) : null;
    this.contracted.ncar_iva = (row.ncar_iva) ? this.Number(row.ncar_iva) : null;
    this.contracted.ncar_retencion = (row.ncar_retencion) ? this.Number(row.ncar_retencion) : null;
    this.contracted.ncar_retencion_isr = (row.ncar_retencion_isr) ? this.Number(row.ncar_retencion_isr) : null;
    this.contracted.ncar_retencion_isr_is = (row.ncar_retencion_isr_is) ? Boolean(row.ncar_retencion_isr_is) : null;
    this.contracted.ncar_total = (row.ncar_total) ? this.Number(row.ncar_total) : null;
    this.contracted.ncar_description = (row.ncar_description) ? row.ncar_description.join("") : null;

    this.contracted.inplug = (row.inplug) ? row.inplug.join("") : null;
    this.contracted.inplug_is = (row.inplug_is) ? Boolean(row.inplug_is) : null;
    this.contracted.inplug_subtotal = (row.inplug_subtotal) ? this.Number(row.inplug_subtotal) : null;
    this.contracted.inplug_iva = (row.inplug_iva) ? this.Number(row.inplug_iva) : null;
    this.contracted.inplug_retencion = (row.inplug_retencion) ? this.Number(row.inplug_retencion) : null;
    this.contracted.inplug_retencion_isr = (row.inplug_retencion_isr) ? this.Number(row.inplug_retencion_isr) : null;
    this.contracted.inplug_retencion_isr_is = (row.inplug_retencion_isr_is) ? Boolean(row.inplug_retencion_isr_is) : null;
    this.contracted.inplug_total = (row.inplug_total) ? this.Number(row.inplug_total) : null;
    this.contracted.inplug_description = (row.inplug_description) ? row.inplug_description.join("") : null;

    //this.actualSelected = row;
    this.selectedModal = this.modalServ.open(modal, { size: 'lg', windowClass: 'bigger' });
  }

  download(type = 'excel') {
    //Genera reporte por filtro normal
    let travelsID = [];
    if(this.travelFilterByID){
      travelsID = this.travelsSelectedById.map( t => { return t.id; });
    }

    window.open(environment.baseUrl + '/' + type + '/travels/contracted?date1=' + this.date1.toString() + '&date2=' + this.date2.toString() + 
                "&brand=" + JSON.stringify(this.brand) + "&customer=" + JSON.stringify(this.customer) +"&destination=" + this.destination + "&product=" + 
                JSON.stringify(this.product) + "&travelType=" + this.travelType + "&travelsID=" + JSON.stringify(travelsID), '_blank');
  }

  selectPick(date){
    this.getDefaultValues();
    this.data = [];
    this.dataAll = [];
  }

  save() {
    this.loading = true;
    this.travelServ.postContractedTravel(this.contracted).subscribe(response => {
      this.actualSelected = response;
      this.loading = false;
      this.selectedModal.close();
      this.search(); //Actualizamos vista con el registro actualizado
      this.toastr.successToastr('El registro se actualizado correctamente', '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  changeTotal() {
    if (this.contracted.subtotal) {
      this.contracted.iva = Math.round(this.contracted.subtotal * 0.16 * 100) / 100;
      this.contracted.retencion = Math.round(this.contracted.subtotal * 0.04 * 100) / 100;
      this.contracted.total = this.contracted.subtotal - this.contracted.retencion + this.contracted.iva;
    }
  }

  filterByDestination(event){
    if(String(event.target.value).trim()){
      this.destination = String(event.target.value).trim();
      this.updateFilter();
      this.formatData();
    }else{
      this.destination = null;
      this.updateFilter();
      this.formatData();
    }
  }

  Number(number){ return (number)?Number(number):0; }

  change(){
    this.contracted.iva = this.contracted.subtotal*0.16;
    this.contracted.retencion = this.contracted.subtotal*0.04;
    if(this.contracted.retencion_isr_is){
      this.contracted.retencion_isr = this.contracted.subtotal*0.0125;
      this.contracted.total = (this.contracted.subtotal*1) + (this.contracted.iva*1) - (this.contracted.retencion*1) - (this.contracted.retencion_isr*1);
    }else{
      this.contracted.retencion_isr = 0;
      this.contracted.total = (this.contracted.subtotal*1) + (this.contracted.iva*1) - (this.contracted.retencion*1);
    }
    //Notas de Credito
    this.contracted.ncre_iva = this.contracted.ncre_subtotal*0.16;
    this.contracted.ncre_retencion = this.contracted.ncre_subtotal*0.04;
    if(this.contracted.ncre_retencion_isr_is){
      this.contracted.ncre_retencion_isr = this.contracted.ncre_subtotal*0.0125;
      this.contracted.ncre_total = (this.contracted.ncre_subtotal*1) + (this.contracted.ncre_iva*1) - (this.contracted.ncre_retencion*1) - (this.contracted.ncre_retencion_isr*1);
    }else{
      this.contracted.ncre_retencion_isr = 0;
      this.contracted.ncre_total = (this.contracted.ncre_subtotal*1) + (this.contracted.ncre_iva*1) - (this.contracted.ncre_retencion*1);
    }
    if(!this.contracted.ncre_is){
      this.contracted.ncre = '';
      this.contracted.ncre_is = false;
      this.contracted.ncre_subtotal = 0;
      this.contracted.ncre_iva = 0;
      this.contracted.ncre_retencion = 0;
      this.contracted.ncre_retencion_isr = 0;
      this.contracted.ncre_retencion_isr_is = false;
      this.contracted.ncre_total = 0;
      this.contracted.ncre_description = '';

    }
    //Notas de Cargo
    this.contracted.ncar_iva = this.contracted.ncar_subtotal*0.16;
    this.contracted.ncar_retencion = this.contracted.ncar_subtotal*0.04;
    if(this.contracted.ncar_retencion_isr_is){
      this.contracted.ncar_retencion_isr = this.contracted.ncar_subtotal*0.0125;
      this.contracted.ncar_total = (this.contracted.ncar_subtotal*1) + (this.contracted.ncar_iva*1) - (this.contracted.ncar_retencion*1) - (this.contracted.ncar_retencion_isr*1);
    }else{
      this.contracted.ncar_retencion_isr = 0;
      this.contracted.ncar_total = (this.contracted.ncar_subtotal*1) + (this.contracted.ncar_iva*1) - (this.contracted.ncar_retencion*1);
    }
    if(!this.contracted.ncar_is){
      this.contracted.ncar = '';
      this.contracted.ncar_is = false;
      this.contracted.ncar_subtotal = 0;
      this.contracted.ncar_iva = 0;
      this.contracted.ncar_retencion = 0;
      this.contracted.ncar_retencion_isr = 0;
      this.contracted.ncar_retencion_isr_is = false;
      this.contracted.ncar_total = 0;
      this.contracted.ncar_description = '';
    }
    //Complemento Factura
    this.contracted.inplug_iva = this.contracted.inplug_subtotal*0.16;
    this.contracted.inplug_retencion = this.contracted.inplug_subtotal*0.04;
    if(this.contracted.inplug_retencion_isr_is){
      this.contracted.inplug_retencion_isr = this.contracted.inplug_subtotal*0.0125;
      this.contracted.inplug_total = (this.contracted.inplug_subtotal*1) + (this.contracted.inplug_iva*1) - (this.contracted.inplug_retencion*1) - (this.contracted.inplug_retencion_isr*1);
    }else{
      this.contracted.inplug_retencion_isr = 0;
      this.contracted.inplug_total = (this.contracted.inplug_subtotal*1) + (this.contracted.inplug_iva*1) - (this.contracted.inplug_retencion*1);
    }
    if(!this.contracted.inplug_is){
      this.contracted.inplug = '';
      this.contracted.inplug_is = false;
      this.contracted.inplug_subtotal = 0;
      this.contracted.inplug_iva = 0;
      this.contracted.inplug_retencion = 0;
      this.contracted.inplug_retencion_isr = 0;
      this.contracted.inplug_retencion_isr_is = false;
      this.contracted.inplug_total = 0;
      this.contracted.inplug_description = '';
    }
  }

  delTravelType(){
    if(this.travelType){
      this.travelType = null;
    }
  }

  filterByTravel(event){
    //Solo se usa para buscar un viaje en especifico
    let _travelID = String(event.target.value).trim();
    if(_travelID){
      this.data = this.dataAll;
      this.data = _.filter(this.data, (d) => { return _.startsWith(String(d.id), _travelID); });
      this.formatData();
    }else{
      this.travelID = null;
      this.data = this.dataAll;
      this.updateFilter();
      this.formatData();
    }
  }

  isNullOrEmpty(data){ return (String(data).trim()) ? true : false; }

  changeIconTotal(){
    let item = (<HTMLInputElement>document.getElementById('totalIcon'));
    if(item.className == 'fas fa-arrow-circle-up'){
      item.className = 'fas fa-arrow-circle-down';
      item.title = 'Mostrar Información';
    }else{
      item.className = 'fas fa-arrow-circle-up';
      item.title = 'Contraer Información';
    }
  }

  changeIconCommDoc(id:number){
    let item = (<HTMLInputElement>document.getElementById('comDocIcon-' + id));
    if(item.className == 'fas fa-arrow-circle-up'){
      item.className = 'fas fa-arrow-circle-down';
      item.title = 'Mostrar Información';
    }else{
      item.className = 'fas fa-arrow-circle-up';
      item.title = 'Ocultar Información';
    }
  }

  addTravelByID(modal){
    this.travelByID = null;
    this.travelSelectedById = null;
    this.travelsSelectedById = [];
    this.modalServ.open(modal, {size: 'lg', centered: true, windowClass: 'bigger'});
  }

  getTravelByID(){
    if(this.travelByID){
      this.loading = true;
      this.travelServ.getTravel(this.travelByID).then( response => {
        this.travelSelectedById = response; //Viaje encontrado de la busqueda por su ID
        if(response.id && response.contracted){
          if(response.status != 'Cancelado'){
            this.loading = false;
            //Pasar el viaje al array para mostrar los viajes que han sido buscados y encontrados
            if(!this.travelsSelectedById.find(e => e.id == this.travelByID)){
              this.travelsSelectedById.push(Object.assign({},this.travelSelectedById));
              this.travelByID = null;
            }else{
              this.toastr.warningToastr("El viaje contratado " + this.travelByID + " ya ha sido seleccionado", "", {enableHTML:true});
            }
          }else{
            this.loading = false;
            this.toastr.warningToastr("No se pudo seleccionar el viaje contratado " + this.travelByID + " porque es un viaje CANCELADO", "", {enableHTML:true});
          }
        }else{
          this.loading = false;
          this.toastr.infoToastr("No se encontró ningún viaje contratado con el ID de viaje " + this.travelByID, "", {enableHTML:true});
        }
      }, error => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), "", {enableHTML: true});
      });
    }else{
      this.toastr.infoToastr("Debes ingresar un ID del Viaje válido para realizar la busqueda", "", {enableHTML:true});
    }
  }

  selectedTravelsToFormatTable(){
    let travelsID = this.travelsSelectedById.map( t => { return t.id; });
    this.loading = true;
    this.travelServ.getFormatDataByTravelID(travelsID).subscribe(response => {
      this.loading = false;
      this.dataAll = response;
      this.data = this.dataAll;
      this.travelFilterByID = true;
      this.travelFilterNormal = false;
      this.formatData();
      this.modalServ.dismissAll();//Cerramos la modal
    }, error => {
      this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), "", {enableHTML: true});
    });
  }

  removeTravel(t:Travel){
    if(t.id){
      let index = this.travelsSelectedById.findIndex(e => e.id == t.id);
      this.travelsSelectedById.splice(index, 1);
    }else{
      this.toastr.errorToastr("No se encontró el viaje a eliminar de la lista de viajes seleccionados", "", {enableHTML: true});
    }
  }
}
